import { Component, OnInit } from '@angular/core';
import { ServicesService } from '../services/services.service';
import { Router } from '@angular/router';
import { FormControl ,FormGroup, Validators } from '@angular/forms';
import { Observable } from 'rxjs';
import swal from 'sweetalert2';

@Component({
  selector: 'app-change-pass',
  templateUrl: './change-pass.component.html',
  styleUrls: ['./change-pass.component.css']
})
export class ChangePassComponent implements OnInit {
  changePasswordForm: FormGroup;

  constructor(private _services: ServicesService, private router: Router) { }
  route:any;
  ngOnInit() {
    this._services.checkToken('status');

    this.changePasswordForm = new FormGroup({
      'old_password': new FormControl('', [Validators.required]),
      'new_password': new FormControl('', [Validators.required]),
      'confirm_new_password': new FormControl('',[Validators.required])
    });
  }
  changePassword(){
    this.route='change-password';
    //console.log(this.changePasswordForm.value['old_password']);
    if(this.changePasswordForm.value['new_password']==this.changePasswordForm.value['confirm_new_password']){
        this._services.requestCreator(this.changePasswordForm.value,this.route,localStorage.getItem('userToken')).subscribe((result: any) => {
          if(this._services.checkToken(result.status)){
            if(result.status == '204'){
              swal({
                title: 'Warning!',
                text: 'Your Password Does Not Match!',
                type: 'warning',
                showCancelButton: false,
                confirmButtonColor: 'rgb(17, 205, 239)',
                cancelButtonColor: 'rgb(245, 54, 92)',
                confirmButtonText: 'Yes'
              }).then(() => {

              });
            }else{
              swal({
                title: 'Password Reset?',
                text: 'You Successfully reset your Password!',
                type: 'success',
                showCancelButton: false,
                confirmButtonColor: 'rgb(17, 205, 239)',
                cancelButtonColor: 'rgb(245, 54, 92)',
                confirmButtonText: 'Yes'
              }).then(() => {
                this.router.navigate(['/clients']);
              });
           }
          }
        });
    }
  }
}
